import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { getTrackLeadState } from 'App/modules/leads/selectors'
import CustomFooter from './CustomFooter'

const CustomFooterContainer = (props) => {
  const [showTrackButtonClickedIndication, setShowTrackButtonClickedIndication] = useState(false)
  const [showTrackInfoDialog, setShowTrackInfoDialog] = useState(false)

  const trackLead = useSelector(state => {
    return getTrackLeadState(state)
  })

  const handleTrackClick = () => {
    window.dispatchEvent(new Event('Folloze.stopTrackingForVisit'))

    setShowTrackButtonClickedIndication(true)
    const timer = setTimeout(() => {
      setShowTrackButtonClickedIndication(false)
    }, 3000);
    return () => clearTimeout(timer);
  }

  const openTrackInfoDialog = () => {
    setShowTrackInfoDialog(true)
  }

  const closeTrackInfoDialog = () => {
    setShowTrackInfoDialog(false)
  }

  return (
    <CustomFooter
      config={props.config}
      themeColorHex={props.themeColorHex}
      trackButtonEnabled={trackLead}
      showTrackButtonClickedIndication={showTrackButtonClickedIndication}
      onTrackClick={handleTrackClick}
      openTrackInfoDialog={openTrackInfoDialog}
      closeTrackInfoDialog={closeTrackInfoDialog}
      showTrackInfoDialog={showTrackInfoDialog}/>
  )
}

CustomFooterContainer.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default CustomFooterContainer
